// PHASE 5: Transformation feedback - building belief
import FeedbackPage from '@/components/FeedbackPage'

export default function TransformationFeedbackPage() {
  return (
    <FeedbackPage
      emoji="🦋"
      title="pages.onboarding.transformationFeedback.title"
    />
  )
}
